module.exports = __webpack_public_path__ + "img/logo-gray.f4f33e38.png";